import { z } from 'zod';

/** Shared list contract: server-side paging, sorting and search for every list endpoint. */
export const LIST_DEFAULT_LIMIT = 50;
export const LIST_MAX_LIMIT = 200;
export const SORT_ORDERS = ['asc', 'desc'] as const;
export type SortOrder = (typeof SORT_ORDERS)[number];

export const listQuerySchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(LIST_MAX_LIMIT).default(LIST_DEFAULT_LIMIT),
  sort: z.string().max(50).optional(),
  order: z.enum(SORT_ORDERS).default('asc'),
  q: z.string().trim().max(200).optional(),
});
export type ListQuery = z.infer<typeof listQuerySchema>;

export interface ListResult<T> {
  rows: T[];
  total: number;
}

export function listResultSchema<T extends z.ZodType>(row: T) {
  return z.object({ rows: z.array(row), total: z.number().int().min(0) });
}
